import type { ICookieConsentSelection } from '@booking-portal/modules/cookie/types/cookie-types';
import { useConsentStore } from '@booking-portal/stores/consent-store';
import { computed } from 'vue';

export function useCookieConsent() {
  const store = useConsentStore();

  function setCookies(options: ICookieConsentSelection) {
    store.setCookies(options);
  }

  function deleteCookies() {
    store.deleteCookies();
  }

  /**
   * Re-open the cookie consent modal from outside (e.g. the footer link). The
   * user's previously stored selection stays intact — the modal reads it back
   * as its initial state. Pair with {@link hideSettings} in the modal's submit
   * handler, or just rely on `setCookies` writing fresh values and the force
   * flag being cleared by `hideSettings`.
   */
  function showSettings() {
    store.showSettings();
  }

  function hideSettings() {
    store.hideSettings();
  }

  return {
    setCookies,
    deleteCookies,
    showSettings,
    hideSettings,
    hasMarketingCookies: computed(() => store.hasMarketingCookies),
    hasNecessaryCookies: computed(() => store.hasNecessaryCookies),
    hasSeenCookieConsent: computed(() => store.hasSeenCookieConsent),
    isSettingsForceShown: computed(() => store.isSettingsForceShown),
  };
}
